<ion-grid>
  <ion-row class="ion-align-items-start ion-justify-content-center">
    <ion-col
      *ngFor="let item of node?.items; let i = index"
      size="12"
      [sizeMd]="columnCount"
    >
      <div class="video-wrapper">
        <div
          class="video-wrapper-inner"
          [innerHTML]="item.embed | safe: 'html'"
        ></div>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
